import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import RouteName from "../../../routes/Route.name";
import {
  actionFetchAdmin,
  actionSetPageAdmin,

} from "../../../actions/AdminUsers.action";
import history from "../../../libs/history.utils";

const useAdminUsersListHook = ({}) => {
  const [editData, setEditData] = useState(null);
  const [isInactiveOpen, setIsInactiveOpen] = useState(false);
  const dispatch = useDispatch();
  const isMountRef = useRef(false);
  const {
    sorting_data: sortingData,
    is_fetching: isFetching,
    query,
    query_data: queryData,
    all,
  } = useSelector((state) => state?.admin);

  useEffect(() => {
    dispatch(
      actionFetchAdmin(
        1,
        {},
        {
          query: isMountRef.current ? query : null,
          query_data: isMountRef.current ? queryData : null,
          
        }
      )
    );
    isMountRef.current = true;
  }, []);

  const handlePageChange = useCallback((type) => {
    dispatch(actionSetPageAdmin(type));
  }, []);

  const queryFilter = useCallback(
    (key, value) => {
      dispatch(
        actionFetchAdmin(1, sortingData, {
          query: key == "SEARCH_TEXT" ? value : query,
          query_data: key == "FILTER_DATA" ? value : queryData,
        })
      );
    },
    [sortingData, query, queryData]
  );

  const handleFilterDataChange = useCallback(
    (value) => {
      queryFilter("FILTER_DATA", value);
    },
    [queryFilter]
  );

  const handleSearchValueChange = useCallback(
    (value) => {
      queryFilter("SEARCH_TEXT", value);
    },
    [queryFilter]
  );

  const handleSortOrderChange = useCallback(
    (row, order) => {
      dispatch(actionSetPageAdmin(1));
      dispatch(
        actionFetchAdmin(
          1,
          { row, order },
          {
            query: query,
            query_data: queryData,
            
          }
        )
      );
    },
    [query, queryData]
  );

  const handleDetail = useCallback((type) => {
    history.push(`${RouteName.ADMIN_DETAIL}${type?.id}`);
  }, []);

  const handleCreate = useCallback(() => {
    history.push(RouteName.ADMIN_CREATE);
  }, []);

  const handleEdit = useCallback((type) => {
    history.push(`${RouteName.ADMIN_UPDATE}${type?.id}`);
  }, []);

  function getInitials(name) {
    if (!name || name.trim() === "") return "";   
    const nameParts = name.split(' ');     
    if (nameParts[0] && nameParts[1]) {       
      const initials = nameParts[0][0]?.toUpperCase() + nameParts[1][0]?.toUpperCase();
      return initials;
    }
    return nameParts[0][0]?.toUpperCase();
  }
  

  const configFilter = useMemo(() => {
    return [
    
      {
        label: "Status",
        name: "status",
        type: "select",
        fields: ["ACTIVE", "INACTIVE"],
      },
    ];
  }, []);

  return {
    handlePageChange,
    handleFilterDataChange,
    handleSearchValueChange,
    handleSortOrderChange,
    handleDetail,
    editData,
    configFilter,
    handleCreate,
    handleEdit,
    getInitials
  };
};

export default useAdminUsersListHook;
